export const actionTypes = {
  START_REQUEST: 'APP.BANNER.LIST.START_REQUEST',
  REQUEST_SUCCESS: 'APP.BANNER.LIST.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.BANNER.LIST.REQUEST_FAILURE',
  CLOSE_BANNER: 'APP.BANNER.CLOSE',

  IS_SHOW_TOUR: 'APP.BANNER.IS_SHOW_TOUR',
  RESET_SHOW_TOUR: 'APP.BANNER.RESET_SHOW_TOUR',
};

export function startRequest() {
  return {
    type: actionTypes.START_REQUEST,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function closeBanner(id) {
  return {
    type: actionTypes.CLOSE_BANNER,
    payload: { id },
  };
}

export function setShowTourStatus(status, isClosed) {
  return {
    type: actionTypes.IS_SHOW_TOUR,
    payload: {
      status: status,
      isClosed: isClosed,
    },
  };
}

export function resetTourStatus() {
  return {
    type: actionTypes.RESET_SHOW_TOUR,
  };
}
